import { styled, Box, TextV1 } from '@withjoy/joykit';
import { animationTransition, animationTransitionExt } from '@shared/utils/animationTransition';

export const TabbedPaneWrapper = styled.div`
  &.fade-in-enter {
    opacity: 0;
  }
  &.fade-in-enter-active {
    opacity: 1;
    transition: ${animationTransition('opacity')};
  }
  &.fade-in-exit {
    opacity: 1;
  }
  &.fade-in-exit-active {
    opacity: 0;
    transition: ${animationTransitionExt({ property: 'opacity', duration: '350ms' })};
  }
`;

export const TabText = styled(TextV1)<{ isActive?: boolean }>`
  color: ${({ theme, isActive }) => (isActive ? theme.colors.mono14 : theme.colors.mono10)};
  transition: ${animationTransition('color')};
  white-space: nowrap;
  font-family: 'Inter UI';
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.13px;
  text-align: center;
`;

export const TabWrapper = styled(Box)`
  cursor: pointer;
  flex: auto;
  text-align: center;
  margin: 0;
  &:hover ${TabText} {
    color: 'blue';
  }
`;

export const TopBarWrapper = styled.div`
  max-width: 100%;
  overflow: visible;
  position: relative;
  display: flex;
  justify-content: center;
`;

export const TopBar = styled.div`
  position: relative;
  display: flex;
  left: 0;
  transition: ${animationTransition('left')};
`;

export const TabsWrapper = styled.ul`
  position: relative;
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 4px;
  flex: 0;
`;
export const IndicatorBar = styled.div`
  position: absolute;
  height: 4px;
  width: 100%;
  bottom: -4px;
  &:before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    background: ${props => props.theme.colors.white};
    opacity: 0.2;
  }
`;

export const Indicator = styled.div`
  position: absolute;
  transition: ${animationTransition('left', 'width')};
  height: 100%;
  background: ${props => props.theme.colors.mono14};
`;
